// import React from 'react';
// import Breadcrumb from '../../components/Breadcrumb';
// import CTA from '../../components/CTA';

// import bgImg from '../../assets/img/cta/cta-bg-2.png';

// import testimonialImg1 from '../../assets/img/testimonial/testi-8.jpg';
// import testimonialImg2 from '../../assets/img/testimonial/testi-9.jpg';
// import testimonialImg3 from '../../assets/img/testimonial/testi-10.jpg';
// import testimonialImg4 from '../../assets/img/testimonial/testi-11.jpg';
// import testimonialImg5 from '../../assets/img/testimonial/testi-12.jpg';
// import testimonialImg6 from '../../assets/img/testimonial/testi-13.jpg';

// import SingleTestimonial from '../../components/Testimonial';

// const TestimonialMain = () => {
//   return (
//     <main>
//       <Breadcrumb pageTitle="Testimonial" />

//       <div className="testimonial__area testimonial__plr p-relative">
//         <div className="container-fluid">
//           <div className="row justify-content-center">
//             <div className="col-xl-7 col-xxl-9">
//               <div className="testimonial__section-box text-center z-index pb-40">
//                 <h4
//                   className="section-blue-subtitle title-anim wow animate__fadeInUp"
//                   data-wow-duration=".9s"
//                   data-wow-delay=".3s"
//                 >
//                   Client Testimonial
//                 </h4>
//                 <h3
//                   className="section-title title-anim wow animate__fadeInUp"
//                   data-wow-duration=".9s"
//                   data-wow-delay=".4s"
//                 >
//                   Perfect Contact This Softwer <br />
//                   Company Manage.
//                 </h3>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".3s"
//             >
//               <SingleTestimonial authorImg={testimonialImg1} />
//             </div>
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".4s"
//             >
//               <SingleTestimonial authorImg={testimonialImg2} />
//             </div>
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".5s"
//             >
//               <SingleTestimonial authorImg={testimonialImg3} />
//             </div>
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".7s"
//             >
//               <SingleTestimonial authorImg={testimonialImg4} />
//             </div>
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".8s"
//             >
//               <SingleTestimonial authorImg={testimonialImg5} />
//             </div>
//             <div
//               className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
//               data-wow-duration=".9s"
//               data-wow-delay=".9s"
//             >
//               <SingleTestimonial authorImg={testimonialImg6} />
//             </div>
//           </div>
//         </div>
//       </div>

//       <CTA ctaBG={bgImg} />
//     </main>
//   );
// };

// export default TestimonialMain;
import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";

import bgImg from "../../assets/img/cta/cta-bg-2.png";

// Remove image imports and use placeholder images
import SingleTestimonial from "../../components/Testimonial";

const TestimonialMain = () => {
  // Create custom testimonial data with different descriptions
  const testimonials = [
    {
      name: "Rajesh Kumar",
      designation: "CEO, TechVision India",
      description:
        "PRD Infotech delivered an exceptional ERP solution that streamlined our entire operation. Their understanding of our business requirements and attention to detail was impressive. The custom features they developed have significantly improved our productivity.",
    },
    {
      name: "Priya Sharma",
      designation: "Marketing Director, GlobalRetail",
      description:
        "We approached PRD Infotech for a complete website redesign and CRM integration. The team was professional, responsive, and delivered beyond our expectations. Our conversion rates have increased by 40% since the launch of the new site.",
    },
    {
      name: "Amit Patel",
      designation: "Operations Manager, LogiTech Solutions",
      description:
        "The mobile application developed by PRD Infotech has revolutionized how we manage our field operations. The app is intuitive, feature-rich, and remarkably stable. Their technical expertise and project management were exceptional throughout.",
    },
    {
      name: "Neha Gupta",
      designation: "Finance Head, Stellar Enterprises",
      description:
        "Implementing the customized accounting module from PRD Infotech has transformed our financial processes. Their team took the time to understand our complex requirements and delivered a solution that perfectly aligned with our needs.",
    },
    {
      name: "Vikram Singh",
      designation: "IT Director, Healthcare Solutions",
      description:
        "PRD Infotech's expertise in developing our patient management system was outstanding. They addressed complex security and compliance requirements while creating an intuitive interface for our staff. Their support during implementation was invaluable.",
    },
    {
      name: "Ananya Desai",
      designation: "Founder, GrowthBox Startups",
      description:
        "As a startup, we needed affordable yet scalable solutions. PRD Infotech understood our constraints and developed a custom CRM that has grown with our business. Their ongoing support and willingness to adapt to our changing needs has made them a true partner.",
    },
  ];

  return (
    <main>
      <Breadcrumb pageTitle="Testimonial" />

      <div className="testimonial__area testimonial__plr p-relative">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-xxl-9">
              <div className="testimonial__section-box text-center z-index pb-40">
                <h4
                  className="section-blue-subtitle title-anim wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".3s"
                >
                  Client Testimonial
                </h4>
                <h3
                  className="section-title title-anim wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".4s"
                >
                  What Our Clients Say About <br />
                  PRD Infotech Solutions
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="col-xl-6 col-lg-12 col-md-12 col-sm-6 pb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={`.${index + 3}s`}
              >
                <SingleTestimonial
                  Name={testimonial.name}
                  Designation={testimonial.designation}
                  Description={testimonial.description}
                  // No image prop, will use default placeholder
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <CTA ctaBG={bgImg} />
    </main>
  );
};

export default TestimonialMain;
